/* ==================== MOBILE MENU ==================== */
function toggleMobileNav(){
  document.querySelector('nav')?.classList.toggle('mobile-open');
}

/* ==================== CART (real Shopify AJAX Cart API) ==================== */
function toggleCart(open){
  document.getElementById('cartOverlay')?.classList.toggle('open', open);
  document.getElementById('cartDrawer')?.classList.toggle('open', open);
  if(open) refreshCart();
}

function refreshCart(){
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => renderCartUI(cart))
    .catch(err => console.error('Cart fetch error', err));
}

function renderCartUI(cart){
  const badge = document.getElementById('cartBadge');
  if(badge) badge.textContent = cart.item_count;

  const itemsEl = document.getElementById('cartItems');
  if(!itemsEl) return;

  if(cart.items.length === 0){
    itemsEl.innerHTML = '<div class="cart-empty">Dein Warenkorb ist noch leer.</div>';
  } else {
    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <div class="cart-item-thumb" style="background-image:url('${item.image}'); background-size:cover;"></div>
        <div class="cart-item-info">
          <strong>${item.product_title}</strong>
          <span>${item.quantity} × ${formatMoney(item.price)}</span>
        </div>
        <span class="cart-item-remove" onclick="removeCartItem(${item.key ? "'" + item.key + "'" : item.id})">Entfernen</span>
      </div>`).join('');
  }

  const subtotalEl = document.getElementById('cartSubtotal');
  if(subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
}

function formatMoney(cents){
  return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
}

function addToCartAjax(variantId, quantity){
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  })
  .then(r => r.json())
  .then(() => { refreshCart(); toggleCart(true); });
}

function removeCartItem(key){
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(r => r.json())
  .then(cart => renderCartUI(cart));
}

// Intercept product form submissions to use AJAX cart instead of full page reload
document.addEventListener('DOMContentLoaded', function(){
  refreshCart();

  const productForm = document.querySelector('form[action^="/cart/add"]');
  if(productForm){
    productForm.addEventListener('submit', function(e){
      e.preventDefault();
      const formData = new FormData(productForm);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(r => r.json())
        .then(() => { refreshCart(); toggleCart(true); })
        .catch(err => console.error('Add to cart error', err));
    });
  }
});

/* ==================== PRODUCT GALLERY (real images) ==================== */
let currentSlide = 0;

function pdSlide(delta){
  const slides = document.querySelectorAll('.pd-slide-img');
  if(slides.length === 0) return;
  currentSlide = (currentSlide + delta + slides.length) % slides.length;
  updateMainSlide();
}

function setPdSlide(i){
  currentSlide = i;
  updateMainSlide();
}

function updateMainSlide(){
  const slides = document.querySelectorAll('.pd-slide-img');
  slides.forEach((img, i) => img.style.display = i === currentSlide ? 'block' : 'none');
  const counter = document.getElementById('pdCounter');
  if(counter) counter.textContent = (currentSlide + 1) + '/' + slides.length;
  document.querySelectorAll('.pd-thumb').forEach((t, i) => t.classList.toggle('active', i === currentSlide));
}

/* ==================== PRODUCT QTY ==================== */
let currentQty = 1;
function changeQty(delta){
  currentQty = Math.max(1, currentQty + delta);
  const qtyLabel = document.getElementById('pdQty');
  const qtyInput = document.getElementById('pdQtyInput');
  if(qtyLabel) qtyLabel.textContent = currentQty;
  if(qtyInput) qtyInput.value = currentQty;
}

/* ==================== PRODUCT TABS ==================== */
function pdTab(tab){
  document.querySelectorAll('.pd-tab-btn').forEach(b => b.classList.toggle('active', b.dataset.tab === tab));
  document.querySelectorAll('.pd-tab-panel').forEach(p => p.classList.toggle('active', p.id === 'tab-' + tab));
}

/* ==================== ACCORDION (Eltern page) ==================== */
function toggleAcc(id){
  document.getElementById(id)?.classList.toggle('open');
}

/* ==================== FAQ SEARCH/ACCORDION (Kontakt page) ==================== */
const faqData = [
  {q:"Wo finde ich den Status meiner Bestellung?", a:"Eine Versandbestätigung mit Tracking geht dir automatisch per E-Mail zu, sobald dein Paket unterwegs ist."},
  {q:"Kann ich meine Bestellung noch ändern?", a:"Solange sie noch nicht in Bearbeitung ist — schreib uns möglichst schnell, wir versuchen es zu ermöglichen."},
  {q:"Wie hoch sind die Versandkosten?", a:"Ab € 30 Bestellwert übernehmen wir den Versand für dich. Darunter fällt eine Versandpauschale an, die im Checkout angezeigt wird."},
  {q:"Wie lange dauert der Versand?", a:"Wir bieten zwei Versandarten an: Standardversand (2–5 Tage) und Express (1–3 Tage), beide mit der österreichischen Post, EU-weit."},
  {q:"Versendet ihr auch ins Ausland?", a:"Ja, wir versenden EU-weit mit der österreichischen Post."},
  {q:"Welche Zahlungsmethoden werden akzeptiert?", a:"Kreditkarte, PayPal, Klarna sowie Apple Pay und Google Pay."},
  {q:"Kann ich meine Bestellung stornieren?", a:"Solange die Produktion noch nicht begonnen hat, ja — kontaktiere uns dazu so schnell wie möglich per E-Mail."},
  {q:"Wie funktioniert die Rückgabe?", a:"Es gilt das gesetzliche 14-tägige Widerrufsrecht innerhalb der EU. Die Figur muss dafür unbenutzt und in Originalverpackung zurückgeschickt werden."},
  {q:"Meine Figur ist beschädigt angekommen — was jetzt?", a:"Schick uns ein Foto der beschädigten Figur per E-Mail oder Kontaktformular, wir kümmern uns um kostenlosen Ersatz."},
  {q:"Gibt es Rabattcodes oder Gutscheine?", a:"Gelegentlich ja — abonniere unseren Newsletter auf der Startseite, um über Aktionen informiert zu werden."},
  {q:"Brauche ich ein Kundenkonto zum Bestellen?", a:"Nein, du kannst auch als Gast bestellen. Ein Konto lohnt sich, wenn du deine Bestellhistorie und Adressen speichern möchtest."},
  {q:"Wie sicher sind meine Daten?", a:"Deine Daten werden ausschließlich zur Bestellabwicklung verwendet und nicht an Dritte für Werbezwecke weitergegeben. Details findest du in unserer Datenschutzerklärung."},
  {q:"Kann ich mir eine bestimmte Figur aussuchen?", a:"Nein — Monstos werden blind verkauft, die Überraschung ist Teil des Konzepts. Die Chancen pro Seltenheitsstufe sind aber transparent angegeben."},
  {q:"Gibt es Duplikate innerhalb eines Sets?", a:"Bei den größeren Sets wird auf Abwechslung geachtet, ein gewisses Duplikat-Risiko bleibt aber wie bei jedem Blindbag-System bestehen."},
  {q:"Wo werden die Figuren hergestellt?", a:"Alles entsteht in unserem Studio in Innsbruck, Österreich — vom 3D-Druck bis zur Verpackung."},
  {q:"Sind die Figuren für Kleinkinder geeignet?", a:"Empfohlen ab 5 Jahren. Bei jüngeren Kindern bitte nur unter Aufsicht, da Kleinteile enthalten sein können."},
  {q:"Kann ich als Firma / Wiederverkäufer bestellen?", a:"Ja, schreib uns über das Kontaktformular für Großmengen oder ein Händlerkonto."},
  {q:"Wie kontaktiere ich den Kundensupport direkt?", a:"Am schnellsten per E-Mail an support@monstos.com oder über das Formular auf dieser Seite."},
  {q:"Bietet ihr Geschenkverpackung an?", a:"Aktuell nicht als separate Option — jedes Set kommt aber bereits ansprechend verpackt."},
  {q:"Was passiert, wenn ein Produkt ausverkauft ist?", a:"Du kannst dich über den Newsletter benachrichtigen lassen, sobald ein Set wieder verfügbar ist."}
];
let faqShowAll = false;
let openFaqIndex = null;

function renderFaq(){
  const searchInput = document.getElementById('faqSearch');
  if(!searchInput) return;
  const query = (searchInput.value || '').toLowerCase().trim();
  let filtered = faqData.filter(f => f.q.toLowerCase().includes(query) || f.a.toLowerCase().includes(query));
  const isSearching = query.length > 0;
  const visible = (isSearching || faqShowAll) ? filtered : filtered.slice(0, 5);

  const listEl = document.getElementById('faqList');
  if(visible.length === 0){
    listEl.innerHTML = '<div class="faq-no-results">Keine passenden Fragen gefunden — schreib uns direkt.</div>';
  } else {
    listEl.innerHTML = visible.map((f, i) => `
      <div class="faq-acc-item ${openFaqIndex === i ? 'open' : ''}">
        <div class="faq-acc-trigger" onclick="toggleFaq(${i})">
          <h4>${f.q}</h4>
          <span class="faq-acc-plus">+</span>
        </div>
        <div class="faq-acc-body"><p>${f.a}</p></div>
      </div>`).join('');
  }

  const moreBtn = document.getElementById('faqMoreBtn');
  if(moreBtn) moreBtn.style.display = (!isSearching && !faqShowAll && filtered.length > 5) ? 'block' : 'none';
}

function toggleFaq(i){
  openFaqIndex = openFaqIndex === i ? null : i;
  renderFaq();
}

document.addEventListener('DOMContentLoaded', function(){
  if(document.getElementById('faqList')) renderFaq();
});

/* ---- CAPTCHA (Kontaktformular) ---- */
let captchaCode = '';
function newCaptcha(){
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  captchaCode = '';
  for(let i=0;i<5;i++) captchaCode += chars[Math.floor(Math.random()*chars.length)];

  const canvas = document.getElementById('captchaCanvas');
  const ans = document.getElementById('captchaAnswer');
  const err = document.getElementById('captchaError');
  if(canvas){
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0,0,canvas.width,canvas.height);
    ctx.fillStyle = '#FFFDF7';
    ctx.fillRect(0,0,canvas.width,canvas.height);

    for(let i=0;i<5;i++){
      ctx.strokeStyle = 'rgba(19,17,24,'+(0.15+Math.random()*0.2)+')';
      ctx.beginPath();
      ctx.moveTo(Math.random()*canvas.width, Math.random()*canvas.height);
      ctx.lineTo(Math.random()*canvas.width, Math.random()*canvas.height);
      ctx.stroke();
    }
    for(let i=0;i<40;i++){
      ctx.fillStyle = 'rgba(19,17,24,'+(0.1+Math.random()*0.15)+')';
      ctx.beginPath();
      ctx.arc(Math.random()*canvas.width, Math.random()*canvas.height, 1, 0, Math.PI*2);
      ctx.fill();
    }
    const colors = ['#7B2FBE','#2FB344','#E8402C','#131118'];
    for(let i=0;i<captchaCode.length;i++){
      ctx.save();
      const x = 18 + i*22;
      const y = 30 + (Math.random()*10-5);
      ctx.translate(x,y);
      ctx.rotate((Math.random()*0.5-0.25));
      ctx.font = 'bold 26px Space Grotesk, sans-serif';
      ctx.fillStyle = colors[i % colors.length];
      ctx.fillText(captchaCode[i], 0, 0);
      ctx.restore();
    }
  }
  if(ans) ans.value = '';
  if(err) err.classList.remove('show');
}

function validateCaptcha(e){
  const ans = document.getElementById('captchaAnswer');
  const err = document.getElementById('captchaError');
  if(!ans || !err) return true;
  if(!ans.value || ans.value.trim().toUpperCase() !== captchaCode){
    err.classList.add('show');
    ans.focus();
    e.preventDefault();
    return false;
  }
  err.classList.remove('show');
  return true;
}

document.addEventListener('DOMContentLoaded', function(){
  if(document.getElementById('captchaCanvas')) newCaptcha();
});

function openStoryModal(){
  const modal = document.getElementById('storyModal');
  if(!modal) return;
  modal.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeStoryModal(){
  const modal = document.getElementById('storyModal');
  if(!modal) return;
  modal.classList.remove('open');
  document.body.style.overflow = '';
}

document.addEventListener('keydown', function(e){
  if(e.key === 'Escape') closeStoryModal();
});

/* ==================== FAVORITEN ==================== */
function escapeHtml(str){
  const div = document.createElement('div');
  div.textContent = str == null ? '' : String(str);
  return div.innerHTML;
}

/* ---- Favoriten ----
   Läuft komplett lokal im Browser (localStorage), kein Backend nötig.
   Funktioniert sofort für jeden Besucher, ist aber pro Gerät/Browser gespeichert
   (kein Sync zwischen Handy und PC — dafür bräuchte es einen Server). */
const MONSTOS_FAV_KEY = 'monstos_favorites';

function getFavorites(){
  try {
    const raw = localStorage.getItem(MONSTOS_FAV_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch(e){ return []; }
}

function saveFavorites(favs){
  try { localStorage.setItem(MONSTOS_FAV_KEY, JSON.stringify(favs)); } catch(e){ /* Speicher voll/blockiert - ignorieren */ }
}

function toggleFavorite(e, btn){
  if(e){ e.preventDefault(); e.stopPropagation(); }
  const productId = String(btn.dataset.productId);
  const favs = getFavorites();
  const idx = favs.findIndex(f => String(f.id) === productId);

  if(idx >= 0){
    favs.splice(idx, 1);
    btn.classList.remove('active');
    const card = btn.closest('#favGrid .product-card');
    if(card) card.remove();
  } else {
    favs.unshift({
      id: productId,
      title: btn.dataset.title || '',
      url: btn.dataset.url || '#',
      image: btn.dataset.image || '',
      price: btn.dataset.price || ''
    });
    btn.classList.add('active');
  }
  saveFavorites(favs);
  updateFavCountBadges();
  maybeShowFavEmptyState();
}

function updateFavCountBadges(){
  const count = getFavorites().length;
  document.querySelectorAll('.fav-count-badge').forEach(el => { el.textContent = count; el.hidden = count === 0; });
}

function maybeShowFavEmptyState(){
  const grid = document.getElementById('favGrid');
  const empty = document.getElementById('favEmpty');
  if(!grid || !empty) return;
  if(grid.children.length === 0){
    grid.style.display = 'none';
    empty.style.display = 'block';
  }
}

function loadFavoriteStates(){
  const ids = new Set(getFavorites().map(f => String(f.id)));
  document.querySelectorAll('.fav-btn[data-product-id]').forEach(btn => {
    btn.classList.toggle('active', ids.has(String(btn.dataset.productId)));
  });
  updateFavCountBadges();
}

function loadFavoritesPage(){
  const grid = document.getElementById('favGrid');
  const empty = document.getElementById('favEmpty');
  if(!grid) return;
  const favs = getFavorites();
  if(favs.length === 0){
    grid.style.display = 'none';
    if(empty) empty.style.display = 'block';
    return;
  }
  grid.innerHTML = favs.map(p => `
    <a href="${p.url}" class="product-card">
      <div class="product-media">
        ${p.image ? `<img src="${escapeHtml(p.image)}" alt="${escapeHtml(p.title)}" style="width:100%; height:100%; object-fit:cover;">` : `<div class="shape shape-1"></div>`}
        <button type="button" class="fav-btn active" data-product-id="${p.id}" data-title="${escapeHtml(p.title)}" data-url="${escapeHtml(p.url)}" data-image="${escapeHtml(p.image)}" data-price="${escapeHtml(p.price)}" onclick="toggleFavorite(event, this)" aria-label="Aus Favoriten entfernen" title="Aus Favoriten entfernen">♥</button>
      </div>
      <div class="product-info">
        <h3>${escapeHtml(p.title)}</h3>
        <div class="product-foot">
          <span class="price">${escapeHtml(p.price)}</span>
          <span class="btn-small">Details ansehen</span>
        </div>
      </div>
    </a>`).join('');
}

/* Bewertungen laufen jetzt komplett über die Judge.me App (siehe main-product.liquid) —
   kein eigener JS-Code mehr nötig. */

document.addEventListener('DOMContentLoaded', function(){
  loadFavoriteStates();
  loadFavoritesPage();
});
